import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, withKeys as _withKeys, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, renderList as _renderList, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/t-1.png'
import _imports_1 from '@/assets/images/t-2.png'
import _imports_2 from '@/assets/images/more.png'
import _imports_3 from '@/assets/images/l-1.png'
import _imports_4 from '@/assets/images/l-5.png'
import _imports_5 from '@/assets/images/l-2.png'
import _imports_6 from '@/assets/images/l-3.png'
import _imports_7 from '@/assets/images/l-4.png'
import _imports_8 from '@/assets/images/q-s.png'
import _imports_9 from '@/assets/images/b-z.png'
import _imports_10 from '@/assets/images/l-6.png'
import _imports_11 from '@/assets/images/l-7.png'
import _imports_12 from '@/assets/images/l-8.png'


const _withScopeId = n => (_pushScopeId("data-v-785837dd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: "site-home" }
const _hoisted_2 = { class: "site-home-nav" }
const _hoisted_3 = {
  key: 0,
  class: "nav-banner nav-banner1"
}
const _hoisted_4 = { class: "site-margin-auto banner-1" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "专业护航招投标，智慧引领新生态", -1))
const _hoisted_6 = { class: "banner-inner" }
const _hoisted_7 = { class: "mr-80" }
const _hoisted_8 = { class: "txt-1" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "txt-2" }, "平台项目数（个）", -1))
const _hoisted_10 = { class: "txt-1" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "txt-2" }, "成交总金额（亿元）", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nav-banner nav-banner2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "site-margin-auto banner-2" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "title" }, "优质采招标采购平台，全新上线"),
    /*#__PURE__*/_createElementVNode("div", { class: "txt-2 txt-s" }, [
      /*#__PURE__*/_createTextVNode(" 简流程，提效率，优服务 "),
      /*#__PURE__*/_createElementVNode("div", { class: "new-line" }, "智能采购，一步到")
    ])
  ])
], -1))
const _hoisted_13 = { class: "search-container site-margin-auto" }
const _hoisted_14 = { class: "addon-before" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "line" }, null, -1))
const _hoisted_16 = { class: "zb-container" }
const _hoisted_17 = { class: "site-margin-auto zb-wrap" }
const _hoisted_18 = { class: "zb-left" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "zb-title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "招标采购"),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_20 = { class: "zb-content" }
const _hoisted_21 = { class: "tab-title" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nav-title" }, "招标计划", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nav-title" }, "招标公告", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nav-title" }, "澄清公告", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nav-title" }, "中标候选人公示", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nav-title" }, "中标结果公告", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_28 = { class: "tab-table" }
const _hoisted_29 = {
  key: 0,
  class: "table-row"
}
const _hoisted_30 = { class: "title" }
const _hoisted_31 = { class: "table-1" }
const _hoisted_32 = {
  key: 0,
  class: "table-6"
}
const _hoisted_33 = {
  key: 1,
  class: "table-2"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "table-4" }, "剩余时间：", -1))
const _hoisted_35 = { class: "table-5" }
const _hoisted_36 = { class: "title" }
const _hoisted_37 = { class: "table-1" }
const _hoisted_38 = {
  key: 0,
  class: "table-6"
}
const _hoisted_39 = {
  key: 1,
  class: "table-2"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "table-4" }, "剩余时间：", -1))
const _hoisted_41 = { class: "table-5" }
const _hoisted_42 = {
  key: 2,
  class: "table-7"
}
const _hoisted_43 = {
  key: 1,
  class: "table-row"
}
const _hoisted_44 = { class: "title" }
const _hoisted_45 = { class: "table-1" }
const _hoisted_46 = {
  key: 0,
  class: "table-6"
}
const _hoisted_47 = {
  key: 1,
  class: "table-2"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "table-4" }, "剩余时间：", -1))
const _hoisted_49 = { class: "table-5" }
const _hoisted_50 = { class: "title" }
const _hoisted_51 = { class: "table-1" }
const _hoisted_52 = {
  key: 0,
  class: "table-6"
}
const _hoisted_53 = {
  key: 1,
  class: "table-2"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "table-4" }, "剩余时间：", -1))
const _hoisted_55 = { class: "table-5" }
const _hoisted_56 = {
  key: 2,
  class: "table-7"
}
const _hoisted_57 = {
  key: 2,
  class: "table-row"
}
const _hoisted_58 = { class: "title" }
const _hoisted_59 = { class: "table-1" }
const _hoisted_60 = {
  key: 0,
  class: "table-6"
}
const _hoisted_61 = {
  key: 1,
  class: "table-2"
}
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "table-4" }, "剩余时间：", -1))
const _hoisted_63 = { class: "table-5" }
const _hoisted_64 = { class: "title" }
const _hoisted_65 = { class: "table-1" }
const _hoisted_66 = {
  key: 0,
  class: "table-6"
}
const _hoisted_67 = {
  key: 1,
  class: "table-2"
}
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "table-4" }, "剩余时间：", -1))
const _hoisted_69 = { class: "table-5" }
const _hoisted_70 = {
  key: 2,
  class: "table-7"
}
const _hoisted_71 = {
  key: 3,
  class: "table-row"
}
const _hoisted_72 = { class: "title" }
const _hoisted_73 = { class: "table-1" }
const _hoisted_74 = {
  key: 0,
  class: "table-6"
}
const _hoisted_75 = {
  key: 1,
  class: "table-2"
}
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "table-4" }, "剩余时间：", -1))
const _hoisted_77 = { class: "table-5" }
const _hoisted_78 = { class: "title" }
const _hoisted_79 = { class: "table-1" }
const _hoisted_80 = {
  key: 0,
  class: "table-6"
}
const _hoisted_81 = {
  key: 1,
  class: "table-2"
}
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "table-4" }, "剩余时间：", -1))
const _hoisted_83 = { class: "table-5" }
const _hoisted_84 = {
  key: 2,
  class: "table-7"
}
const _hoisted_85 = {
  key: 1,
  class: "empty-content"
}
const _hoisted_86 = { class: "zb-right" }
const _hoisted_87 = { class: "login-container" }
const _hoisted_88 = { class: "login-top" }
const _hoisted_89 = {
  key: 0,
  class: "login-content"
}
const _hoisted_90 = { class: "login-0" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-user" }, null, -1))
const _hoisted_92 = { class: "login-1" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-2" }, "登录后查看专属服务内容", -1))
const _hoisted_94 = { class: "handle-btns" }
const _hoisted_95 = { style: {"text-align":"center"} }
const _hoisted_96 = {
  key: 1,
  class: "login-content"
}
const _hoisted_97 = { class: "logined" }
const _hoisted_98 = { class: "login-0" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-user" }, null, -1))
const _hoisted_100 = { class: "login-1" }
const _hoisted_101 = { class: "login-2" }
const _hoisted_102 = { style: {"text-align":"center"} }
const _hoisted_103 = { class: "tools-container" }
const _hoisted_104 = { class: "tools-1" }
const _hoisted_105 = { class: "tools-7 mt-40" }
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tools-3" }, "注册指南", -1))
const _hoisted_108 = [
  _hoisted_106,
  _hoisted_107
]
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1))
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tools-3" }, "我的项目", -1))
const _hoisted_111 = [
  _hoisted_109,
  _hoisted_110
]
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://file.youzhicai.com/files/BidderHelp.rar",
  download: ""
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "tools-title" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_5,
      alt: ""
    }),
    /*#__PURE__*/_createElementVNode("div", { class: "tools-3" }, "投标指南")
  ])
], -1))
const _hoisted_113 = /*#__PURE__*/_createStaticVNode("<div class=\"tools-7\" data-v-785837dd><a href=\"https://toolcdn.youzhicai.com/tools/BidderTools.zip\" download data-v-785837dd><div class=\"tools-title\" data-v-785837dd><img src=\"" + _imports_6 + "\" alt=\"\" data-v-785837dd><div class=\"tools-3\" data-v-785837dd>投标文件编制工具</div></div></a><a href=\"https://toolcdn.youzhicai.com/ca.zip\" download data-v-785837dd><div class=\"tools-title\" data-v-785837dd><img src=\"" + _imports_7 + "\" alt=\"\" data-v-785837dd><div class=\"tools-3\" data-v-785837dd>数字证书助手</div></div></a></div>", 1)
const _hoisted_114 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  alt: "question",
  style: {"margin-right":"3px"}
}, null, -1))
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  alt: "help",
  style: {"margin-right":"3px"}
}, null, -1))
const _hoisted_117 = { class: "tools-1" }
const _hoisted_118 = { class: "tools-7 mt-40" }
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1))
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tools-3" }, "大宗及零星采购", -1))
const _hoisted_121 = [
  _hoisted_119,
  _hoisted_120
]
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_10,
  alt: ""
}, null, -1))
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tools-3" }, "供应商库管理", -1))
const _hoisted_124 = [
  _hoisted_122,
  _hoisted_123
]
const _hoisted_125 = /*#__PURE__*/_createStaticVNode("<div class=\"tools-7\" data-v-785837dd><div class=\"tools-title\" data-v-785837dd><img src=\"" + _imports_11 + "\" alt=\"\" data-v-785837dd><div class=\"tools-3\" data-v-785837dd>企业案例</div></div><a href=\"https://toolcdn.youzhicai.com/ca.zip\" download data-v-785837dd><div class=\"tools-title\" data-v-785837dd><img src=\"" + _imports_12 + "\" alt=\"\" data-v-785837dd><div class=\"tools-3\" data-v-785837dd>数字证书助手</div></div></a></div>", 1)
const _hoisted_126 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  alt: "question",
  style: {"margin-right":"3px"}
}, null, -1))
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  alt: "help",
  style: {"margin-right":"3px"}
}, null, -1))
const _hoisted_129 = { class: "cp-container" }
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cp-title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "平台产品服务"),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_131 = { class: "cp-content" }
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "全流程电子招投标", -1))
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "交易系统", -1))
const _hoisted_134 = [
  _hoisted_132,
  _hoisted_133
]
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "电子招投标", -1))
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "专项工具", -1))
const _hoisted_137 = [
  _hoisted_135,
  _hoisted_136
]
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "项目管理", -1))
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "平台", -1))
const _hoisted_140 = [
  _hoisted_138,
  _hoisted_139
]
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "AI招标采购", -1))
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "知识大模型", -1))
const _hoisted_143 = [
  _hoisted_141,
  _hoisted_142
]
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "智能辅助", -1))
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "评审系统", -1))
const _hoisted_146 = [
  _hoisted_144,
  _hoisted_145
]
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "全过程工程", -1))
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "咨询管理系统", -1))
const _hoisted_149 = [
  _hoisted_147,
  _hoisted_148
]
const _hoisted_150 = { class: "zc-container" }
const _hoisted_151 = { class: "zfcg-content site-margin-auto" }
const _hoisted_152 = { class: "zfcg-left" }
const _hoisted_153 = { class: "zfcg-title" }
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "政府采购", -1))
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_158 = { class: "zfcg-list" }
const _hoisted_159 = { class: "list-left" }
const _hoisted_160 = { class: "list-right" }
const _hoisted_161 = {
  key: 0,
  class: "table-row"
}
const _hoisted_162 = { class: "title" }
const _hoisted_163 = { class: "table-1" }
const _hoisted_164 = {
  key: 0,
  class: "table-6"
}
const _hoisted_165 = {
  key: 1,
  class: "table-2"
}
const _hoisted_166 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "table-4" }, "剩余时间：", -1))
const _hoisted_167 = { class: "table-5" }
const _hoisted_168 = { class: "title" }
const _hoisted_169 = { class: "table-1" }
const _hoisted_170 = {
  key: 0,
  class: "table-6"
}
const _hoisted_171 = {
  key: 1,
  class: "table-2"
}
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "table-4" }, "剩余时间：", -1))
const _hoisted_173 = { class: "table-5" }
const _hoisted_174 = {
  key: 2,
  class: "table-7"
}
const _hoisted_175 = {
  key: 1,
  class: "table-row"
}
const _hoisted_176 = { class: "title" }
const _hoisted_177 = { class: "table-1" }
const _hoisted_178 = {
  key: 0,
  class: "table-6"
}
const _hoisted_179 = {
  key: 1,
  class: "table-2"
}
const _hoisted_180 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "table-4" }, "剩余时间：", -1))
const _hoisted_181 = { class: "table-5" }
const _hoisted_182 = { class: "title" }
const _hoisted_183 = { class: "table-1" }
const _hoisted_184 = {
  key: 0,
  class: "table-6"
}
const _hoisted_185 = {
  key: 1,
  class: "table-2"
}
const _hoisted_186 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "table-4" }, "剩余时间：", -1))
const _hoisted_187 = { class: "table-5" }
const _hoisted_188 = {
  key: 2,
  class: "table-7"
}
const _hoisted_189 = {
  key: 2,
  class: "table-row"
}
const _hoisted_190 = { class: "title" }
const _hoisted_191 = { class: "table-1" }
const _hoisted_192 = {
  key: 0,
  class: "table-6"
}
const _hoisted_193 = {
  key: 1,
  class: "table-2"
}
const _hoisted_194 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "table-4" }, "剩余时间：", -1))
const _hoisted_195 = { class: "table-5" }
const _hoisted_196 = { class: "title" }
const _hoisted_197 = { class: "table-1" }
const _hoisted_198 = {
  key: 0,
  class: "table-6"
}
const _hoisted_199 = {
  key: 1,
  class: "table-2"
}
const _hoisted_200 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "table-4" }, "剩余时间：", -1))
const _hoisted_201 = { class: "table-5" }
const _hoisted_202 = {
  key: 2,
  class: "table-7"
}
const _hoisted_203 = {
  key: 1,
  class: "empty-content"
}
const _hoisted_204 = { class: "zfcg-right" }
const _hoisted_205 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sort-0" }, "业绩排名", -1))
const _hoisted_206 = {
  key: 0,
  class: "sort-content"
}
const _hoisted_207 = { class: "sort-4" }
const _hoisted_208 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sort-1 n-1" }, "1", -1))
const _hoisted_209 = { class: "sort-2" }
const _hoisted_210 = { class: "sort-3" }
const _hoisted_211 = {
  key: 1,
  class: "sort-content"
}
const _hoisted_212 = { class: "sort-4" }
const _hoisted_213 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sort-1 n-2" }, "2", -1))
const _hoisted_214 = { class: "sort-2" }
const _hoisted_215 = { class: "sort-3" }
const _hoisted_216 = {
  key: 2,
  class: "sort-content"
}
const _hoisted_217 = { class: "sort-4" }
const _hoisted_218 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sort-1 n-3" }, "3", -1))
const _hoisted_219 = { class: "sort-2" }
const _hoisted_220 = { class: "sort-3" }
const _hoisted_221 = {
  key: 3,
  class: "sort-content"
}
const _hoisted_222 = { class: "sort-4" }
const _hoisted_223 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sort-1 n-o" }, "4", -1))
const _hoisted_224 = { class: "sort-2" }
const _hoisted_225 = { class: "sort-3" }
const _hoisted_226 = {
  key: 4,
  class: "sort-content"
}
const _hoisted_227 = { class: "sort-4" }
const _hoisted_228 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sort-1 n-o" }, "5", -1))
const _hoisted_229 = { class: "sort-2" }
const _hoisted_230 = { class: "sort-3" }
const _hoisted_231 = {
  key: 5,
  class: "sort-content"
}
const _hoisted_232 = { class: "sort-4" }
const _hoisted_233 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sort-1 n-o" }, "6", -1))
const _hoisted_234 = { class: "sort-2" }
const _hoisted_235 = { class: "sort-3" }
const _hoisted_236 = {
  key: 6,
  class: "sort-content"
}
const _hoisted_237 = { class: "sort-4" }
const _hoisted_238 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sort-1 n-o" }, "7", -1))
const _hoisted_239 = { class: "sort-2" }
const _hoisted_240 = { class: "sort-3" }
const _hoisted_241 = {
  key: 7,
  class: "sort-content"
}
const _hoisted_242 = { class: "sort-4" }
const _hoisted_243 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sort-1 n-o" }, "8", -1))
const _hoisted_244 = { class: "sort-2" }
const _hoisted_245 = { class: "sort-3" }
const _hoisted_246 = {
  key: 8,
  class: "sort-content"
}
const _hoisted_247 = { class: "sort-4" }
const _hoisted_248 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sort-1 n-o" }, "9", -1))
const _hoisted_249 = { class: "sort-2" }
const _hoisted_250 = { class: "sort-3" }
const _hoisted_251 = {
  key: 9,
  class: "sort-content"
}
const _hoisted_252 = { class: "sort-4" }
const _hoisted_253 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sort-1 n-o" }, "10", -1))
const _hoisted_254 = { class: "sort-2" }
const _hoisted_255 = { class: "sort-3" }
const _hoisted_256 = { class: "jycg-content site-margin-auto" }
const _hoisted_257 = { class: "jycg-left" }
const _hoisted_258 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "jycg-title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "寻源快采"),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_259 = { class: "jycg-wrap" }
const _hoisted_260 = { class: "jycg-nav" }
const _hoisted_261 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nav-title" }, "采购公告", -1))
const _hoisted_262 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nav-title" }, "澄清公告", -1))
const _hoisted_263 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nav-title" }, "结果公示", -1))
const _hoisted_264 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nav-title" }, "其他公告", -1))
const _hoisted_265 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_266 = { class: "jycg-table" }
const _hoisted_267 = {
  key: 0,
  class: "table-row"
}
const _hoisted_268 = { class: "title" }
const _hoisted_269 = { class: "table-1" }
const _hoisted_270 = {
  key: 0,
  class: "table-6"
}
const _hoisted_271 = {
  key: 1,
  class: "table-2"
}
const _hoisted_272 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "table-4" }, "剩余时间：", -1))
const _hoisted_273 = { class: "table-5" }
const _hoisted_274 = { class: "title" }
const _hoisted_275 = { class: "table-1" }
const _hoisted_276 = {
  key: 0,
  class: "table-6"
}
const _hoisted_277 = {
  key: 1,
  class: "table-2"
}
const _hoisted_278 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "table-4" }, "剩余时间：", -1))
const _hoisted_279 = { class: "table-5" }
const _hoisted_280 = {
  key: 2,
  class: "table-7"
}
const _hoisted_281 = {
  key: 1,
  class: "table-row"
}
const _hoisted_282 = { class: "title" }
const _hoisted_283 = { class: "table-1" }
const _hoisted_284 = {
  key: 0,
  class: "table-6"
}
const _hoisted_285 = {
  key: 1,
  class: "table-2"
}
const _hoisted_286 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "table-4" }, "剩余时间：", -1))
const _hoisted_287 = { class: "table-5" }
const _hoisted_288 = { class: "title" }
const _hoisted_289 = { class: "table-1" }
const _hoisted_290 = {
  key: 0,
  class: "table-6"
}
const _hoisted_291 = {
  key: 1,
  class: "table-2"
}
const _hoisted_292 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "table-4" }, "剩余时间：", -1))
const _hoisted_293 = { class: "table-5" }
const _hoisted_294 = {
  key: 2,
  class: "table-7"
}
const _hoisted_295 = {
  key: 2,
  class: "table-row"
}
const _hoisted_296 = { class: "title" }
const _hoisted_297 = { class: "table-1" }
const _hoisted_298 = {
  key: 0,
  class: "table-6"
}
const _hoisted_299 = {
  key: 1,
  class: "table-2"
}
const _hoisted_300 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "table-4" }, "剩余时间：", -1))
const _hoisted_301 = { class: "table-5" }
const _hoisted_302 = { class: "title" }
const _hoisted_303 = { class: "table-1" }
const _hoisted_304 = {
  key: 0,
  class: "table-6"
}
const _hoisted_305 = {
  key: 1,
  class: "table-2"
}
const _hoisted_306 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "table-4" }, "剩余时间：", -1))
const _hoisted_307 = { class: "table-5" }
const _hoisted_308 = {
  key: 2,
  class: "table-7"
}
const _hoisted_309 = {
  key: 1,
  class: "empty-content"
}
const _hoisted_310 = { class: "jycg-right" }
const _hoisted_311 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sort-0" }, "活跃投标人（供应商）", -1))
const _hoisted_312 = { class: "sort-content" }
const _hoisted_313 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sort-1" }, "1.", -1))
const _hoisted_314 = { class: "sort-2" }
const _hoisted_315 = { class: "sort-content" }
const _hoisted_316 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sort-1" }, "2.", -1))
const _hoisted_317 = { class: "sort-2" }
const _hoisted_318 = { class: "sort-content" }
const _hoisted_319 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sort-1" }, "3.", -1))
const _hoisted_320 = { class: "sort-2" }
const _hoisted_321 = { class: "sort-content" }
const _hoisted_322 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sort-1" }, "4.", -1))
const _hoisted_323 = { class: "sort-2" }
const _hoisted_324 = { class: "sort-content" }
const _hoisted_325 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sort-1" }, "5.", -1))
const _hoisted_326 = { class: "sort-2" }
const _hoisted_327 = { class: "sort-content" }
const _hoisted_328 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sort-1" }, "6.", -1))
const _hoisted_329 = { class: "sort-2" }
const _hoisted_330 = { class: "sort-content" }
const _hoisted_331 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sort-1" }, "7.", -1))
const _hoisted_332 = { class: "sort-2" }
const _hoisted_333 = { class: "sort-content" }
const _hoisted_334 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sort-1" }, "8.", -1))
const _hoisted_335 = { class: "sort-2" }
const _hoisted_336 = { class: "sort-content" }
const _hoisted_337 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sort-1" }, "9.", -1))
const _hoisted_338 = { class: "sort-2" }
const _hoisted_339 = { class: "sort-content" }
const _hoisted_340 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sort-1" }, "10.", -1))
const _hoisted_341 = { class: "sort-2" }
const _hoisted_342 = { class: "zx-container" }
const _hoisted_343 = { class: "zx-content site-margin-auto" }
const _hoisted_344 = { class: "zf-content" }
const _hoisted_345 = { class: "title" }
const _hoisted_346 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "title-1" }, "政策法规"),
  /*#__PURE__*/_createElementVNode("div", { class: "title-2" }, "Policies And Regulations")
], -1))
const _hoisted_347 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_348 = { class: "body" }
const _hoisted_349 = ["onClick"]
const _hoisted_350 = { class: "hy-content" }
const _hoisted_351 = { class: "title" }
const _hoisted_352 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "title-1" }, "行业资讯"),
  /*#__PURE__*/_createElementVNode("div", { class: "title-2" }, "Industry News")
], -1))
const _hoisted_353 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_354 = { class: "body" }
const _hoisted_355 = ["onClick"]

import { defineAsyncComponent, onMounted, ref, shallowRef } from "vue";
import { SearchOutlined } from "@ant-design/icons-vue";
import { useRouteHopping } from "@/utils/use-route-to";
import useDownload from "@/utils/use-download";
import {
  zbcgList,
  zfcgList,
  getBidderCount,
  getTenderCount,
  getProjectCount,
  getAmountCount,
  getActiveBidder,
  newsListPage,
  zhcgList,
  yjsort,
  getMenuPermissionsByPath,
} from "@/api/site-home/index";
import { useBaiduTongji } from "@/utils/use-baidutongji";
import { useUserStore } from "@/store/modules/user/index";
import { useRouter } from "vue-router";

import { defineComponent } from "vue";
import { errorInfoDis } from "@/utils/project-utils";
import { setDocumentTitle } from "@/utils/document-title-utils";

const __default__ = defineComponent({
  name: "SiteHome",
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

useBaiduTongji("");

const ContactUs = defineAsyncComponent(
  () => import("./components/contact-us.vue")
);
const NoPermission = defineAsyncComponent(
  () => import("./components/no-permission.vue")
);
const userStore = useUserStore();
const { currentRoute } = useRouter();
const loginUrl = `${
  process.env.VUE_APP_DOMAIN
}/sso-cross-api/router/relogin/yzczb?url=${encodeURIComponent(
  window.location.href
)}`;
const regUrl = `${process.env.VUE_APP_LOGIN_DOMANI}/homeweb/#/register`;
const searchVal = shallowRef<string>();
const contactVisible = shallowRef<boolean>(false);
const bidderCount = shallowRef<number>(0);
const tenderCount = shallowRef<number>(0);
const projectCount = shallowRef<number>(0);
const amountCount = shallowRef<number>(0);
const activeKey = shallowRef<string>("2");
const zhcgKey = shallowRef<string>("2");
const govKey = shallowRef<number>(2);
const zbcgData = shallowRef<any[]>([]);
const zcfgData = shallowRef<any[]>([]);
const zhcgData = shallowRef<any[]>([]);
const hyzxData = shallowRef<any[]>([]);
const data = shallowRef<any[]>([]);
const activeBidData = shallowRef<any[]>([]);
const yjSortData = shallowRef<any[]>([]);
const currentActive = shallowRef<number>(1);

const getCurrentTimePeriod = () => {
  const now = new Date();
  const hour = now.getHours();

  if (hour >= 0 && hour < 12) {
    return "上 午 好";
  } else if (hour >= 12 && hour < 18) {
    return "下 午 好";
  } else {
    return "晚 上 好";
  }
};
const registerHandle = () => {
  if (roleTabKey.value === 1) {
    window.location.href = regUrl;
  } else if (roleTabKey.value === 2) {
    contactVisible.value = true;
  }
};
const loginHandle = () => {
  window.location.href = loginUrl;
};
const checkGovNav = (val: number) => {
  govKey.value = val;
  queryZfcgList(val);
};
const roleTabKey = shallowRef<number>(1);
const changeLoginTab = (key: number) => {
  if (roleTabKey.value === key) return;

  if (userStore.userName && key === 1 && !userStore.userRole.includes(3)) {
    permissionVisible.value = true;
    return;
  } else if (
    userStore.userName &&
    key === 2 &&
    !userStore.userRole.includes(2) &&
    !userStore.userRole.includes(1)
  ) {
    permissionVisible.value = true;
    return;
  }
  roleTabKey.value = key;
};
const searchType = shallowRef<number>(1);
const goSearchResult = () => {
  // useRouteHopping("/site-search", {
  //   name: searchVal.value,
  // });
  if (searchVal.value) {
    useRouteHopping("/site-search", {
      searchType: searchType.value,
      name: searchVal.value,
    });
  } else {
    useRouteHopping("/site-search", {
      searchType: searchType.value,
    });
    userStore.setMenuKey(`/site-search`);
  }
};
const toNewsListPage = (key: string) => {
  userStore.setMenuKey(key);
  useRouteHopping(key);
};
const toSearch = (pType: number) => {
  let bType: undefined | number = undefined;
  if (pType === 1) {
    // 招标采购
    bType = Number(activeKey.value);
  } else if (pType === 2) {
    // 政府采购
    bType = govKey.value;
  } else if (pType === 3) {
    // 寻源快采
    bType = Number(zhcgKey.value);
  }
  userStore.setMenuKey(`/site-search?pType=${pType}`);
  useRouteHopping("/site-search", {
    pType,
    bType,
  });
};
const jumpUserManage = (activeKeyHome?: string) => {
  if (!activeKeyHome) {
    if (roleTabKey.value === 1) {
      window.open(`${process.env.VUE_APP_DOMAIN}/portal-bidder/`);
    } else {
      if (
        userStore.userRole.includes(2) ||
        (userStore.userRole.includes(1) && userStore.userRole.includes(2))
      ) {
        window.open(`${process.env.VUE_APP_DOMAIN}/portal-agency/`);
      } else if (userStore.userRole.includes(1)) {
        window.open(`${process.env.VUE_APP_DOMAIN}/portal-tender/`);
      } else {
        permissionVisible.value = true;
      }
    }
  } else {
    const list = menuRoleList.value.filter((item: any) => {
      return (
        item.menuPath === "/project-manage/simple/tender-project" &&
        item.subjectRoles.includes(1)
      );
    });
    const list2 = menuRoleList.value.filter((item: any) => {
      return (
        item.menuPath === "/project-manage/simple/tender-project" &&
        item.subjectRoles.includes(2)
      );
    });
    if (list2?.length) {
      window.open(
        `${process.env.VUE_APP_DOMAIN}/portal-agency/project-manage/simple/tender-project`
      );
    } else if (list?.length) {
      window.open(
        `${process.env.VUE_APP_DOMAIN}/portal-tender/project-manage/simple/tender-project`
      );
    } else {
      permissionVisible.value = true;
    }
  }
};
const permissionVisible = shallowRef<boolean>(false);
const jumpMyProject = () => {
  const list = menuRoleList.value.filter((item: any) => {
    return (
      item.menuPath === "/project-manage/project" &&
      item.subjectRoles.includes(3)
    );
  });
  if (list?.length) {
    window.open(
      `${process.env.VUE_APP_DOMAIN}/portal-bidder/project-manage/project`
    );
  } else {
    permissionVisible.value = true;
  }
};
const jumpSupplierLibrary = () => {
  const list = menuRoleList.value.filter((item: any) => {
    return (
      item.menuPath === "/supplier-library" && item.subjectRoles.includes(1)
    );
  });
  const list2 = menuRoleList.value.filter((item: any) => {
    return (
      item.menuPath === "/supplier-library" && item.subjectRoles.includes(2)
    );
  });
  if (list2?.length) {
    window.open(`${process.env.VUE_APP_DOMAIN}/portal-agency/supplier-library`);
  } else if (list?.length) {
    window.open(`${process.env.VUE_APP_DOMAIN}/portal-tender/supplier-library`);
  } else {
    permissionVisible.value = true;
  }
};
const downloadRegisterGuide = () => {
  useDownload(
    "https://www.youzhicai.com/Files/%E4%BC%98%E8%B4%A8%E9%87%87%E4%BA%91%E9%87%87%E8%B4%AD%E5%B9%B3%E5%8F%B0%E6%B3%A8%E5%86%8C%E6%8C%87%E5%AF%BC230811.pdf"
  );
};
const toDetail = (id: string) => {
  if (!id) {
    errorInfoDis("缺失公告ID");
    return false;
  }
  window.open(`/bultin-detail/${id}-1.html`);
};
const toDetailNews = (id: string) => {
  // useRouteParam("SiteNews", {
  //   id: `${id}.html`,
  // });
  window.open(`/site-news/${id}.html`);
};
const queryBidCount = async () => {
  try {
    const res = await getBidderCount();
    bidderCount.value = res || 0;
  } catch (error: any) {
    errorInfoDis(error.message || "查询投标人数量失败");
  }
};
const queryTendCount = async () => {
  try {
    const res = await getTenderCount();
    tenderCount.value = res || 0;
  } catch (error: any) {
    errorInfoDis(error.message || "查询招标人数量失败");
  }
};
const queryProjectCount = async () => {
  try {
    const res = await getProjectCount();
    projectCount.value = res || 0;
  } catch (error: any) {
    errorInfoDis(error.message || "查询平台项目数失败");
  }
};
const queryAmountCount = async () => {
  try {
    const res = await getAmountCount();
    amountCount.value = res || 0;
  } catch (error: any) {
    errorInfoDis(error.message || "查询成交总金额失败");
  }
};
const queryActiveBidder = async () => {
  try {
    const res = await getActiveBidder();
    activeBidData.value = res || [];
  } catch (error: any) {
    errorInfoDis(error.message || "查询活跃投标人列表失败");
  }
};
const queryYjSortData = async () => {
  try {
    const res = await yjsort();
    yjSortData.value = res || [];
  } catch (error: any) {
    errorInfoDis(error.message || "查询业绩排名列表失败");
  }
};
const queryZfcgList = async (category: number) => {
  try {
    const res = await zfcgList({ category });
    data.value = res || [];
  } catch (error: any) {
    errorInfoDis(error.message || "查询招标采购列表失败");
  }
};
const queryZbcgList = async (category: string) => {
  try {
    const res = await zbcgList({ category });
    zbcgData.value = res || [];
  } catch (error: any) {
    errorInfoDis(error.message || "查询招标采购列表失败");
  }
};
const queryZhcgList = async (category: string) => {
  try {
    const res = await zhcgList({ category });
    zhcgData.value = res || [];
  } catch (error: any) {
    errorInfoDis(error.message || "查询寻源快采列表失败");
    return;
  }
};
const queryZcfgList = async () => {
  try {
    const res = await newsListPage({
      category: 4,
      pageParam: { pageNum: 1, pageSize: 5 },
    });
    if (!res) {
      errorInfoDis("未查询到结果");
      return;
    }
    zcfgData.value = res.list || [];
  } catch (error: any) {
    errorInfoDis(error.message || "查询政策法规列表失败");
    return;
  }
};
const queryHyzxList = async () => {
  try {
    const res = await newsListPage({
      category: 5,
      pageParam: { pageNum: 1, pageSize: 5 },
    });
    if (!res) {
      errorInfoDis("未查询到结果");
      return;
    }
    hyzxData.value = res.list || [];
  } catch (error: any) {
    errorInfoDis(error.message || "查询行业资讯列表失败");
    return;
  }
};
const runHelpCenter = (type: number) => {
  if (type === 1) {
    useRouteHopping("/common-problem");
  } else {
    useRouteHopping("/help-center");
  }
};
const selectZbKey = (key: string) => {
  queryZbcgList(key);
};
const selectZhcgKey = (key: string) => {
  queryZhcgList(key);
};
// 菜单角色权限列表
const menuRoleList = ref<any[]>([]);
// 查询当前登录人菜单权限
const queryMenuPermissionsByPath = async () => {
  try {
    const menuList = [
      "/project-manage/project",
      "/project-manage/simple/tender-project",
      "/supplier-library",
    ];
    const res = await getMenuPermissionsByPath({
      menuPaths: menuList,
    });
    menuRoleList.value = res || [];
  } catch (error: any) {
    errorInfoDis(error.message || "查询菜单权限失败");
  }
};
onMounted(async () => {
  setDocumentTitle("首页");
  queryBidCount();
  queryTendCount();
  queryProjectCount();
  queryAmountCount();
  queryZbcgList(activeKey.value);
  queryZfcgList(govKey.value);
  queryZhcgList(zhcgKey.value);
  queryActiveBidder();
  queryZcfgList();
  queryHyzxList();
  queryYjSortData();

  setTimeout(() => {
    const name = currentRoute.value.query.name;
    if (name) {
      searchVal.value = name as string;
    }
    if (userStore.userName) {
      queryMenuPermissionsByPath();
    }
    // 判断当前角色
    if (userStore.userRole.includes(3)) {
      roleTabKey.value = 1;
    } else if (
      userStore.userRole.includes(2) ||
      userStore.userRole.includes(1)
    ) {
      roleTabKey.value = 2;
    }
  }, 300);
});

return (_ctx: any,_cache: any) => {
  const _component_a_carousel = _resolveComponent("a-carousel")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_empty = _resolveComponent("a-empty")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_carousel, { autoplay: "" }, {
        default: _withCtx(() => [
          (_unref(projectCount) && _unref(amountCount))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(projectCount)), 1),
                      _hoisted_9
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(amountCount)), 1),
                      _hoisted_11
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _hoisted_12
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_a_input, {
          size: "large",
          onKeyup: _cache[1] || (_cache[1] = _withKeys(() => goSearchResult(), ["enter"])),
          value: _unref(searchVal),
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_isRef(searchVal) ? (searchVal).value = $event : null)),
          valueModifiers: { trim: true },
          class: "search-input",
          placeholder: "请输入项目名称、编号或通过发布单位进行搜索"
        }, {
          addonBefore: _withCtx(() => [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_a_select, {
                value: _unref(searchType),
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_isRef(searchType) ? (searchType).value = $event : null)),
                class: "search-select",
                size: "large"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select_option, { value: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode("项目")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: 2 }, {
                    default: _withCtx(() => [
                      _createTextVNode("发布单位")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"]),
              _hoisted_15
            ])
          ]),
          _: 1
        }, 8, ["value"]),
        _createVNode(_component_a_button, {
          size: "large",
          type: "primary",
          class: "search-btn",
          onClick: _cache[3] || (_cache[3] = () => goSearchResult())
        }, {
          icon: _withCtx(() => [
            _createVNode(_unref(SearchOutlined))
          ]),
          default: _withCtx(() => [
            _createTextVNode(" 搜索 ")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", null, [
                _createVNode(_component_a_tabs, {
                  activeKey: _unref(activeKey),
                  "onUpdate:activeKey": _cache[4] || (_cache[4] = ($event: any) => (_isRef(activeKey) ? (activeKey).value = $event : null)),
                  onChange: selectZbKey
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_tab_pane, { key: "1" }, {
                      tab: _withCtx(() => [
                        _hoisted_22
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_tab_pane, {
                      key: "2",
                      "force-render": ""
                    }, {
                      tab: _withCtx(() => [
                        _hoisted_23
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_tab_pane, { key: "3" }, {
                      tab: _withCtx(() => [
                        _hoisted_24
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_tab_pane, { key: "4" }, {
                      tab: _withCtx(() => [
                        _hoisted_25
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_tab_pane, { key: "5" }, {
                      tab: _withCtx(() => [
                        _hoisted_26
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["activeKey"])
              ]),
              _createElementVNode("a", {
                onClick: _cache[5] || (_cache[5] = () => toSearch(1))
              }, [
                _createTextVNode(" 查看更多 "),
                _hoisted_27
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              (_unref(zbcgData).length)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_unref(zbcgData)[0] || _unref(zbcgData)[1])
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          (_unref(zbcgData)[0])
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "table-0",
                                onClick: _cache[6] || (_cache[6] = () => toDetail(_unref(zbcgData)[0].sid))
                              }, [
                                _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(zbcgData)[0]["title"]), 1),
                                _createElementVNode("div", _hoisted_31, [
                                  (
                          _unref(zbcgData)[0]['durations'] &&
                          !['3', '4', '5'].includes(_unref(activeKey))
                        )
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (_unref(zbcgData)[0]['durations']['isOvertime'])
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_32, " 公告时间已结束 "))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                              _hoisted_34,
                                              _createElementVNode("span", _hoisted_35, _toDisplayString(_unref(zbcgData)[0]["durations"]["days"]) + " 天 " + _toDisplayString(_unref(zbcgData)[0]["durations"]["hours"]) + " 时 " + _toDisplayString(_unref(zbcgData)[0]["durations"]["minutes"]) + " 分 ", 1)
                                            ]))
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["table-3", 
                          !_unref(zbcgData)[0]['durations'] ||
                          ['3', '4', '5'].includes(_unref(activeKey))
                            ? 'right-content'
                            : ''
                        ])
                                  }, _toDisplayString(_unref(zbcgData)[0]["releaseTime"].split(" ")[0]), 3)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_unref(zbcgData)[1])
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: "table-0",
                                onClick: _cache[7] || (_cache[7] = () => toDetail(_unref(zbcgData)[1].sid))
                              }, [
                                _createElementVNode("div", _hoisted_36, _toDisplayString(_unref(zbcgData)[1]["title"]), 1),
                                _createElementVNode("div", _hoisted_37, [
                                  (
                          _unref(zbcgData)[1]['durations'] &&
                          !['3', '4', '5'].includes(_unref(activeKey))
                        )
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (_unref(zbcgData)[1]['durations']['isOvertime'])
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_38, " 公告时间已结束 "))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                              _hoisted_40,
                                              _createElementVNode("span", _hoisted_41, _toDisplayString(_unref(zbcgData)[1]["durations"]["days"]) + " 天 " + _toDisplayString(_unref(zbcgData)[1]["durations"]["hours"]) + " 时 " + _toDisplayString(_unref(zbcgData)[1]["durations"]["minutes"]) + " 分 ", 1)
                                            ]))
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["table-3", 
                          !_unref(zbcgData)[1]['durations'] ||
                          ['3', '4', '5'].includes(_unref(activeKey))
                            ? 'right-content'
                            : ''
                        ])
                                  }, _toDisplayString(_unref(zbcgData)[1]["releaseTime"].split(" ")[0]), 3)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_unref(zbcgData)[1])
                            ? (_openBlock(), _createElementBlock("div", _hoisted_42))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(zbcgData)[2] || _unref(zbcgData)[3])
                      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                          (_unref(zbcgData)[2])
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "table-0",
                                onClick: _cache[8] || (_cache[8] = () => toDetail(_unref(zbcgData)[2].sid))
                              }, [
                                _createElementVNode("div", _hoisted_44, _toDisplayString(_unref(zbcgData)[2]["title"]), 1),
                                _createElementVNode("div", _hoisted_45, [
                                  (
                          _unref(zbcgData)[2]['durations'] &&
                          !['3', '4', '5'].includes(_unref(activeKey))
                        )
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (_unref(zbcgData)[2]['durations']['isOvertime'])
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_46, " 公告时间已结束 "))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                              _hoisted_48,
                                              _createElementVNode("span", _hoisted_49, _toDisplayString(_unref(zbcgData)[2]["durations"]["days"]) + " 天 " + _toDisplayString(_unref(zbcgData)[2]["durations"]["hours"]) + " 时 " + _toDisplayString(_unref(zbcgData)[2]["durations"]["minutes"]) + " 分 ", 1)
                                            ]))
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["table-3", 
                          !_unref(zbcgData)[2]['durations'] ||
                          ['3', '4', '5'].includes(_unref(activeKey))
                            ? 'right-content'
                            : ''
                        ])
                                  }, _toDisplayString(_unref(zbcgData)[2]["releaseTime"].split(" ")[0]), 3)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_unref(zbcgData)[3])
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: "table-0",
                                onClick: _cache[9] || (_cache[9] = () => toDetail(_unref(zbcgData)[3].sid))
                              }, [
                                _createElementVNode("div", _hoisted_50, _toDisplayString(_unref(zbcgData)[3]["title"]), 1),
                                _createElementVNode("div", _hoisted_51, [
                                  (
                          _unref(zbcgData)[3]['durations'] &&
                          !['3', '4', '5'].includes(_unref(activeKey))
                        )
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (_unref(zbcgData)[3]['durations']['isOvertime'])
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_52, " 公告时间已结束 "))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                              _hoisted_54,
                                              _createElementVNode("span", _hoisted_55, _toDisplayString(_unref(zbcgData)[3]["durations"]["days"]) + " 天 " + _toDisplayString(_unref(zbcgData)[3]["durations"]["hours"]) + " 时 " + _toDisplayString(_unref(zbcgData)[3]["durations"]["minutes"]) + " 分 ", 1)
                                            ]))
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["table-3", 
                          !_unref(zbcgData)[3]['durations'] ||
                          ['3', '4', '5'].includes(_unref(activeKey))
                            ? 'right-content'
                            : ''
                        ])
                                  }, _toDisplayString(_unref(zbcgData)[3]["releaseTime"].split(" ")[0]), 3)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_unref(zbcgData)[3])
                            ? (_openBlock(), _createElementBlock("div", _hoisted_56))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(zbcgData)[4] || _unref(zbcgData)[5])
                      ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                          (_unref(zbcgData)[4])
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "table-0",
                                onClick: _cache[10] || (_cache[10] = () => toDetail(_unref(zbcgData)[4].sid))
                              }, [
                                _createElementVNode("div", _hoisted_58, _toDisplayString(_unref(zbcgData)[4]["title"]), 1),
                                _createElementVNode("div", _hoisted_59, [
                                  (
                          _unref(zbcgData)[4]['durations'] &&
                          !['3', '4', '5'].includes(_unref(activeKey))
                        )
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (_unref(zbcgData)[4]['durations']['isOvertime'])
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_60, " 公告时间已结束 "))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                              _hoisted_62,
                                              _createElementVNode("span", _hoisted_63, _toDisplayString(_unref(zbcgData)[4]["durations"]["days"]) + " 天 " + _toDisplayString(_unref(zbcgData)[4]["durations"]["hours"]) + " 时 " + _toDisplayString(_unref(zbcgData)[4]["durations"]["minutes"]) + " 分 ", 1)
                                            ]))
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["table-3", 
                          !_unref(zbcgData)[4]['durations'] ||
                          ['3', '4', '5'].includes(_unref(activeKey))
                            ? 'right-content'
                            : ''
                        ])
                                  }, _toDisplayString(_unref(zbcgData)[4]["releaseTime"].split(" ")[0]), 3)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_unref(zbcgData)[5])
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: "table-0",
                                onClick: _cache[11] || (_cache[11] = () => toDetail(_unref(zbcgData)[5].sid))
                              }, [
                                _createElementVNode("div", _hoisted_64, _toDisplayString(_unref(zbcgData)[5]["title"]), 1),
                                _createElementVNode("div", _hoisted_65, [
                                  (
                          _unref(zbcgData)[5]['durations'] &&
                          !['3', '4', '5'].includes(_unref(activeKey))
                        )
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (_unref(zbcgData)[5]['durations']['isOvertime'])
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_66, " 公告时间已结束 "))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                              _hoisted_68,
                                              _createElementVNode("span", _hoisted_69, _toDisplayString(_unref(zbcgData)[5]["durations"]["days"]) + " 天 " + _toDisplayString(_unref(zbcgData)[5]["durations"]["hours"]) + " 时 " + _toDisplayString(_unref(zbcgData)[5]["durations"]["minutes"]) + " 分 ", 1)
                                            ]))
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["table-3", 
                          !_unref(zbcgData)[5]['durations'] ||
                          ['3', '4', '5'].includes(_unref(activeKey))
                            ? 'right-content'
                            : ''
                        ])
                                  }, _toDisplayString(_unref(zbcgData)[5]["releaseTime"].split(" ")[0]), 3)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_unref(zbcgData)[5])
                            ? (_openBlock(), _createElementBlock("div", _hoisted_70))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(zbcgData)[6] || _unref(zbcgData)[7])
                      ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                          (_unref(zbcgData)[6])
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "table-0",
                                onClick: _cache[12] || (_cache[12] = () => toDetail(_unref(zbcgData)[6].sid))
                              }, [
                                _createElementVNode("div", _hoisted_72, _toDisplayString(_unref(zbcgData)[6]["title"]), 1),
                                _createElementVNode("div", _hoisted_73, [
                                  (
                          _unref(zbcgData)[6]['durations'] &&
                          !['3', '4', '5'].includes(_unref(activeKey))
                        )
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (_unref(zbcgData)[6]['durations']['isOvertime'])
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_74, " 公告时间已结束 "))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_75, [
                                              _hoisted_76,
                                              _createElementVNode("span", _hoisted_77, _toDisplayString(_unref(zbcgData)[6]["durations"]["days"]) + " 天 " + _toDisplayString(_unref(zbcgData)[6]["durations"]["hours"]) + " 时 " + _toDisplayString(_unref(zbcgData)[6]["durations"]["minutes"]) + " 分 ", 1)
                                            ]))
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["table-3", 
                          !_unref(zbcgData)[6]['durations'] ||
                          ['3', '4', '5'].includes(_unref(activeKey))
                            ? 'right-content'
                            : ''
                        ])
                                  }, _toDisplayString(_unref(zbcgData)[6]["releaseTime"].split(" ")[0]), 3)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_unref(zbcgData)[7])
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: "table-0",
                                onClick: _cache[13] || (_cache[13] = () => toDetail(_unref(zbcgData)[7].sid))
                              }, [
                                _createElementVNode("div", _hoisted_78, _toDisplayString(_unref(zbcgData)[7]["title"]), 1),
                                _createElementVNode("div", _hoisted_79, [
                                  (
                          _unref(zbcgData)[7]['durations'] &&
                          !['3', '4', '5'].includes(_unref(activeKey))
                        )
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (_unref(zbcgData)[7]['durations']['isOvertime'])
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_80, " 公告时间已结束 "))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_81, [
                                              _hoisted_82,
                                              _createElementVNode("span", _hoisted_83, _toDisplayString(_unref(zbcgData)[7]["durations"]["days"]) + " 天 " + _toDisplayString(_unref(zbcgData)[7]["durations"]["hours"]) + " 时 " + _toDisplayString(_unref(zbcgData)[7]["durations"]["minutes"]) + " 分 ", 1)
                                            ]))
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["table-3", 
                          !_unref(zbcgData)[7]['durations'] ||
                          ['3', '4', '5'].includes(_unref(activeKey))
                            ? 'right-content'
                            : ''
                        ])
                                  }, _toDisplayString(_unref(zbcgData)[7]["releaseTime"].split(" ")[0]), 3)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_unref(zbcgData)[7])
                            ? (_openBlock(), _createElementBlock("div", _hoisted_84))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createElementBlock("div", _hoisted_85, [
                    _createVNode(_component_a_empty)
                  ]))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_86, [
          _createElementVNode("div", _hoisted_87, [
            _createElementVNode("div", _hoisted_88, [
              _createElementVNode("div", {
                class: _normalizeClass(["btn btn-1", {
                  active: _unref(roleTabKey) === 1,
                  'active-btn1': _unref(roleTabKey) === 1,
                  'no-active-btn1': _unref(roleTabKey) !== 1,
                  disabled:
                    _unref(userStore).userName && !_unref(userStore).userRole.includes(3),
                }]),
                onClick: _cache[14] || (_cache[14] = () => changeLoginTab(1))
              }, " 投标人/供应商 ", 2),
              _createElementVNode("div", {
                class: _normalizeClass(["btn btn-2", {
                  active: _unref(roleTabKey) === 2,
                  'active-btn2': _unref(roleTabKey) === 2,
                  'no-active-btn2': _unref(roleTabKey) !== 2,
                  disabled:
                    _unref(userStore).userName &&
                    !_unref(userStore).userRole.includes(1) &&
                    !_unref(userStore).userRole.includes(2),
                }]),
                onClick: _cache[15] || (_cache[15] = () => changeLoginTab(2))
              }, " 代理机构/采购人 ", 2)
            ]),
            (!_unref(userStore).userName)
              ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                  _createElementVNode("div", _hoisted_90, [
                    _hoisted_91,
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_92, _toDisplayString(getCurrentTimePeriod()) + " ！", 1),
                      _hoisted_93
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_94, [
                    _createVNode(_component_a_button, {
                      onClick: _cache[16] || (_cache[16] = () => loginHandle()),
                      type: "primary",
                      class: "login-btn"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 立即登录 ")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_95, [
                    _createVNode(_component_a_button, {
                      onClick: _cache[17] || (_cache[17] = () => registerHandle()),
                      class: "register-btn"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 免费注册 ")
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_96, [
                  _createElementVNode("div", _hoisted_97, [
                    _createElementVNode("div", _hoisted_98, [
                      _hoisted_99,
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_100, "您好！" + _toDisplayString(_unref(userStore).userName), 1),
                        _createElementVNode("div", _hoisted_101, _toDisplayString(_unref(userStore).subjectName), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_102, [
                      _createVNode(_component_a_button, {
                        onClick: _cache[18] || (_cache[18] = () => jumpUserManage()),
                        type: "primary",
                        class: "enter-btn"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 进入用户管理平台 ")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]))
          ]),
          _createElementVNode("div", _hoisted_103, [
            (_unref(roleTabKey) === 1)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_104, [
                    _createElementVNode("div", _hoisted_105, [
                      (!_unref(userStore).userName)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            onClick: downloadRegisterGuide,
                            class: "tools-title"
                          }, _hoisted_108))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "tools-title",
                            onClick: jumpMyProject
                          }, _hoisted_111)),
                      _hoisted_112
                    ]),
                    _hoisted_113
                  ]),
                  _createElementVNode("div", _hoisted_114, [
                    _createElementVNode("a", {
                      onClick: _cache[19] || (_cache[19] = ($event: any) => (runHelpCenter(0))),
                      class: "tools-2"
                    }, [
                      _hoisted_115,
                      _createTextVNode(" 常见问题 ")
                    ]),
                    _createElementVNode("a", {
                      onClick: _cache[20] || (_cache[20] = ($event: any) => (runHelpCenter(1))),
                      class: "tools-2"
                    }, [
                      _hoisted_116,
                      _createTextVNode(" 帮助中心 ")
                    ])
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_117, [
                    _createElementVNode("div", _hoisted_118, [
                      _createElementVNode("div", {
                        onClick: _cache[21] || (_cache[21] = ($event: any) => (jumpUserManage('3'))),
                        class: "tools-title"
                      }, _hoisted_121),
                      _createElementVNode("div", {
                        onClick: jumpSupplierLibrary,
                        class: "tools-title"
                      }, _hoisted_124)
                    ]),
                    _hoisted_125
                  ]),
                  _createElementVNode("div", _hoisted_126, [
                    _createElementVNode("a", {
                      onClick: _cache[22] || (_cache[22] = ($event: any) => (runHelpCenter(0))),
                      class: "tools-2"
                    }, [
                      _hoisted_127,
                      _createTextVNode(" 常见问题 ")
                    ]),
                    _createElementVNode("a", {
                      onClick: _cache[23] || (_cache[23] = ($event: any) => (runHelpCenter(1))),
                      class: "tools-2"
                    }, [
                      _hoisted_128,
                      _createTextVNode(" 帮助中心 ")
                    ])
                  ])
                ], 64))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_129, [
      _hoisted_130,
      _createElementVNode("div", _hoisted_131, [
        _createElementVNode("div", {
          onMouseenter: _cache[24] || (_cache[24] = ($event: any) => (currentActive.value = 1)),
          class: _normalizeClass(_unref(currentActive) === 1 ? 'cp-system' : 'cp-item cp-item-1')
        }, _hoisted_134, 34),
        _createElementVNode("div", {
          onMouseenter: _cache[25] || (_cache[25] = ($event: any) => (currentActive.value = 2)),
          class: _normalizeClass(_unref(currentActive) === 2 ? 'cp-system' : 'cp-item cp-item-2')
        }, _hoisted_137, 34),
        _createElementVNode("div", {
          onMouseenter: _cache[26] || (_cache[26] = ($event: any) => (currentActive.value = 3)),
          class: _normalizeClass(_unref(currentActive) === 3 ? 'cp-system' : 'cp-item cp-item-3')
        }, _hoisted_140, 34),
        _createElementVNode("div", {
          onMouseenter: _cache[27] || (_cache[27] = ($event: any) => (currentActive.value = 4)),
          class: _normalizeClass(_unref(currentActive) === 4 ? 'cp-system' : 'cp-item cp-item-4')
        }, _hoisted_143, 34),
        _createElementVNode("div", {
          onMouseenter: _cache[28] || (_cache[28] = ($event: any) => (currentActive.value = 5)),
          class: _normalizeClass(_unref(currentActive) === 5 ? 'cp-system' : 'cp-item cp-item-5')
        }, _hoisted_146, 34),
        _createElementVNode("div", {
          onMouseenter: _cache[29] || (_cache[29] = ($event: any) => (currentActive.value = 6)),
          class: _normalizeClass(_unref(currentActive) === 6 ? 'cp-system' : 'cp-item cp-item-6')
        }, _hoisted_149, 34)
      ])
    ]),
    _createElementVNode("div", _hoisted_150, [
      _createElementVNode("div", _hoisted_151, [
        _createElementVNode("div", _hoisted_152, [
          _createElementVNode("div", _hoisted_153, [
            _hoisted_154,
            _hoisted_155,
            _hoisted_156,
            _createElementVNode("a", {
              class: "more",
              onClick: _cache[30] || (_cache[30] = () => toSearch(2))
            }, [
              _createTextVNode(" 查看更多 "),
              _hoisted_157
            ])
          ]),
          _createElementVNode("div", _hoisted_158, [
            _createElementVNode("div", _hoisted_159, [
              _createElementVNode("div", {
                class: _normalizeClass(["tab-name", _unref(govKey) === 11 ? 'active' : '']),
                onClick: _cache[31] || (_cache[31] = ($event: any) => (checkGovNav(11)))
              }, " 需求调查 ", 2),
              _createElementVNode("div", {
                class: _normalizeClass(["tab-name", _unref(govKey) === 2 ? 'active' : '']),
                onClick: _cache[32] || (_cache[32] = ($event: any) => (checkGovNav(2)))
              }, " 采购公告 ", 2),
              _createElementVNode("div", {
                class: _normalizeClass(["tab-name", _unref(govKey) === 3 ? 'active' : '']),
                onClick: _cache[33] || (_cache[33] = ($event: any) => (checkGovNav(3)))
              }, " 澄清公告 ", 2),
              _createElementVNode("div", {
                class: _normalizeClass(["tab-name", _unref(govKey) === 5 ? 'active' : '']),
                onClick: _cache[34] || (_cache[34] = ($event: any) => (checkGovNav(5)))
              }, " 结果公告 ", 2),
              _createElementVNode("div", {
                class: _normalizeClass(["tab-name", _unref(govKey) === 9 ? 'active' : '']),
                onClick: _cache[35] || (_cache[35] = ($event: any) => (checkGovNav(9)))
              }, " 其他公告 ", 2)
            ]),
            _createElementVNode("div", _hoisted_160, [
              (_unref(data).length)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_unref(data)[0] || _unref(data)[1])
                      ? (_openBlock(), _createElementBlock("div", _hoisted_161, [
                          (_unref(data)[0])
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "table-0",
                                onClick: _cache[36] || (_cache[36] = () => toDetail(_unref(data)[0].sid))
                              }, [
                                _createElementVNode("div", _hoisted_162, _toDisplayString(_unref(data)[0]["title"]), 1),
                                _createElementVNode("div", _hoisted_163, [
                                  (_unref(data)[0]['durations'] && ![3, 5].includes(_unref(govKey)))
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (_unref(data)[0]['durations']['isOvertime'])
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_164, " 公告时间已结束 "))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_165, [
                                              _hoisted_166,
                                              _createElementVNode("span", _hoisted_167, _toDisplayString(_unref(data)[0]["durations"]["days"]) + " 天 " + _toDisplayString(_unref(data)[0]["durations"]["hours"]) + " 时 " + _toDisplayString(_unref(data)[0]["durations"]["minutes"]) + " 分 ", 1)
                                            ]))
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["table-3", 
                          !_unref(data)[0]['durations'] || [3, 5].includes(_unref(govKey))
                            ? 'right-content'
                            : ''
                        ])
                                  }, _toDisplayString(_unref(data)[0]["releaseTime"].split(" ")[0]), 3)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_unref(data)[1])
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: "table-0",
                                onClick: _cache[37] || (_cache[37] = () => toDetail(_unref(data)[1].sid))
                              }, [
                                _createElementVNode("div", _hoisted_168, _toDisplayString(_unref(data)[1]["title"]), 1),
                                _createElementVNode("div", _hoisted_169, [
                                  (_unref(data)[1]['durations'] && ![3, 5].includes(_unref(govKey)))
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (_unref(data)[1]['durations']['isOvertime'])
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_170, " 公告时间已结束 "))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_171, [
                                              _hoisted_172,
                                              _createElementVNode("span", _hoisted_173, _toDisplayString(_unref(data)[1]["durations"]["days"]) + " 天 " + _toDisplayString(_unref(data)[1]["durations"]["hours"]) + " 时 " + _toDisplayString(_unref(data)[1]["durations"]["minutes"]) + " 分 ", 1)
                                            ]))
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["table-3", 
                          !_unref(data)[1]['durations'] || [3, 5].includes(_unref(govKey))
                            ? 'right-content'
                            : ''
                        ])
                                  }, _toDisplayString(_unref(data)[1]["releaseTime"].split(" ")[0]), 3)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_unref(data)[1])
                            ? (_openBlock(), _createElementBlock("div", _hoisted_174))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(data)[2] || _unref(data)[3])
                      ? (_openBlock(), _createElementBlock("div", _hoisted_175, [
                          (_unref(data)[2])
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "table-0",
                                onClick: _cache[38] || (_cache[38] = () => toDetail(_unref(data)[2].sid))
                              }, [
                                _createElementVNode("div", _hoisted_176, _toDisplayString(_unref(data)[2]["title"]), 1),
                                _createElementVNode("div", _hoisted_177, [
                                  (_unref(data)[2]['durations'] && ![3, 5].includes(_unref(govKey)))
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (_unref(data)[2]['durations']['isOvertime'])
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_178, " 公告时间已结束 "))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_179, [
                                              _hoisted_180,
                                              _createElementVNode("span", _hoisted_181, _toDisplayString(_unref(data)[2]["durations"]["days"]) + " 天 " + _toDisplayString(_unref(data)[2]["durations"]["hours"]) + " 时 " + _toDisplayString(_unref(data)[2]["durations"]["minutes"]) + " 分 ", 1)
                                            ]))
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["table-3", 
                          !_unref(data)[2]['durations'] || [3, 5].includes(_unref(govKey))
                            ? 'right-content'
                            : ''
                        ])
                                  }, _toDisplayString(_unref(data)[2]["releaseTime"].split(" ")[0]), 3)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_unref(data)[3])
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: "table-0",
                                onClick: _cache[39] || (_cache[39] = () => toDetail(_unref(data)[3].sid))
                              }, [
                                _createElementVNode("div", _hoisted_182, _toDisplayString(_unref(data)[3]["title"]), 1),
                                _createElementVNode("div", _hoisted_183, [
                                  (_unref(data)[3]['durations'] && ![3, 5].includes(_unref(govKey)))
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (_unref(data)[3]['durations']['isOvertime'])
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_184, " 公告时间已结束 "))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_185, [
                                              _hoisted_186,
                                              _createElementVNode("span", _hoisted_187, _toDisplayString(_unref(data)[3]["durations"]["days"]) + " 天 " + _toDisplayString(_unref(data)[3]["durations"]["hours"]) + " 时 " + _toDisplayString(_unref(data)[3]["durations"]["minutes"]) + " 分 ", 1)
                                            ]))
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["table-3", 
                          !_unref(data)[3]['durations'] || [3, 5].includes(_unref(govKey))
                            ? 'right-content'
                            : ''
                        ])
                                  }, _toDisplayString(_unref(data)[3]["releaseTime"].split(" ")[0]), 3)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_unref(data)[3])
                            ? (_openBlock(), _createElementBlock("div", _hoisted_188))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(data)[4] || _unref(data)[5])
                      ? (_openBlock(), _createElementBlock("div", _hoisted_189, [
                          (_unref(data)[4])
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "table-0",
                                onClick: _cache[40] || (_cache[40] = () => toDetail(_unref(data)[4].sid))
                              }, [
                                _createElementVNode("div", _hoisted_190, _toDisplayString(_unref(data)[4]["title"]), 1),
                                _createElementVNode("div", _hoisted_191, [
                                  (_unref(data)[4]['durations'] && ![3, 5].includes(_unref(govKey)))
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (_unref(data)[4]['durations']['isOvertime'])
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_192, " 公告时间已结束 "))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_193, [
                                              _hoisted_194,
                                              _createElementVNode("span", _hoisted_195, _toDisplayString(_unref(data)[4]["durations"]["days"]) + " 天 " + _toDisplayString(_unref(data)[4]["durations"]["hours"]) + " 时 " + _toDisplayString(_unref(data)[4]["durations"]["minutes"]) + " 分 ", 1)
                                            ]))
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["table-3", 
                          !_unref(data)[4]['durations'] || [3, 5].includes(_unref(govKey))
                            ? 'right-content'
                            : ''
                        ])
                                  }, _toDisplayString(_unref(data)[4]["releaseTime"].split(" ")[0]), 3)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_unref(data)[5])
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: "table-0",
                                onClick: _cache[41] || (_cache[41] = () => toDetail(_unref(data)[5].sid))
                              }, [
                                _createElementVNode("div", _hoisted_196, _toDisplayString(_unref(data)[5]["title"]), 1),
                                _createElementVNode("div", _hoisted_197, [
                                  (_unref(data)[5]['durations'] && ![3, 5].includes(_unref(govKey)))
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (_unref(data)[5]['durations']['isOvertime'])
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_198, " 公告时间已结束 "))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_199, [
                                              _hoisted_200,
                                              _createElementVNode("span", _hoisted_201, _toDisplayString(_unref(data)[5]["durations"]["days"]) + " 天 " + _toDisplayString(_unref(data)[5]["durations"]["hours"]) + " 时 " + _toDisplayString(_unref(data)[5]["durations"]["minutes"]) + " 分 ", 1)
                                            ]))
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["table-3", 
                          !_unref(data)[5]['durations'] || [3, 5].includes(_unref(govKey))
                            ? 'right-content'
                            : ''
                        ])
                                  }, _toDisplayString(_unref(data)[5]["releaseTime"].split(" ")[0]), 3)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_unref(data)[5])
                            ? (_openBlock(), _createElementBlock("div", _hoisted_202))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createElementBlock("div", _hoisted_203, [
                    _createVNode(_component_a_empty)
                  ]))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_204, [
          _hoisted_205,
          (_unref(yjSortData).length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_unref(yjSortData)[0])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_206, [
                      _createElementVNode("div", _hoisted_207, [
                        _hoisted_208,
                        _createElementVNode("span", _hoisted_209, _toDisplayString(_unref(yjSortData)[0]["bidderName"]), 1)
                      ]),
                      _createElementVNode("div", _hoisted_210, _toDisplayString(_unref(yjSortData)[0]["winPrice"]), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_unref(yjSortData)[1])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_211, [
                      _createElementVNode("div", _hoisted_212, [
                        _hoisted_213,
                        _createElementVNode("span", _hoisted_214, _toDisplayString(_unref(yjSortData)[1]["bidderName"]), 1)
                      ]),
                      _createElementVNode("div", _hoisted_215, _toDisplayString(_unref(yjSortData)[1]["winPrice"]), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_unref(yjSortData)[2])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_216, [
                      _createElementVNode("div", _hoisted_217, [
                        _hoisted_218,
                        _createElementVNode("span", _hoisted_219, _toDisplayString(_unref(yjSortData)[2]["bidderName"]), 1)
                      ]),
                      _createElementVNode("div", _hoisted_220, _toDisplayString(_unref(yjSortData)[2]["winPrice"]), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_unref(yjSortData)[3])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_221, [
                      _createElementVNode("div", _hoisted_222, [
                        _hoisted_223,
                        _createElementVNode("span", _hoisted_224, _toDisplayString(_unref(yjSortData)[3]["bidderName"]), 1)
                      ]),
                      _createElementVNode("div", _hoisted_225, _toDisplayString(_unref(yjSortData)[3]["winPrice"]), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_unref(yjSortData)[4])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_226, [
                      _createElementVNode("div", _hoisted_227, [
                        _hoisted_228,
                        _createElementVNode("span", _hoisted_229, _toDisplayString(_unref(yjSortData)[4]["bidderName"]), 1)
                      ]),
                      _createElementVNode("div", _hoisted_230, _toDisplayString(_unref(yjSortData)[4]["winPrice"]), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_unref(yjSortData)[5])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_231, [
                      _createElementVNode("div", _hoisted_232, [
                        _hoisted_233,
                        _createElementVNode("span", _hoisted_234, _toDisplayString(_unref(yjSortData)[5]["bidderName"]), 1)
                      ]),
                      _createElementVNode("div", _hoisted_235, _toDisplayString(_unref(yjSortData)[5]["winPrice"]), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_unref(yjSortData)[6])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_236, [
                      _createElementVNode("div", _hoisted_237, [
                        _hoisted_238,
                        _createElementVNode("span", _hoisted_239, _toDisplayString(_unref(yjSortData)[6]["bidderName"]), 1)
                      ]),
                      _createElementVNode("div", _hoisted_240, _toDisplayString(_unref(yjSortData)[6]["winPrice"]), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_unref(yjSortData)[7])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_241, [
                      _createElementVNode("div", _hoisted_242, [
                        _hoisted_243,
                        _createElementVNode("span", _hoisted_244, _toDisplayString(_unref(yjSortData)[7]["bidderName"]), 1)
                      ]),
                      _createElementVNode("div", _hoisted_245, _toDisplayString(_unref(yjSortData)[7]["winPrice"]), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_unref(yjSortData)[8])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_246, [
                      _createElementVNode("div", _hoisted_247, [
                        _hoisted_248,
                        _createElementVNode("span", _hoisted_249, _toDisplayString(_unref(yjSortData)[8]["bidderName"]), 1)
                      ]),
                      _createElementVNode("div", _hoisted_250, _toDisplayString(_unref(yjSortData)[8]["winPrice"]), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_unref(yjSortData)[9])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_251, [
                      _createElementVNode("div", _hoisted_252, [
                        _hoisted_253,
                        _createElementVNode("span", _hoisted_254, _toDisplayString(_unref(yjSortData)[9]["bidderName"]), 1)
                      ]),
                      _createElementVNode("div", _hoisted_255, _toDisplayString(_unref(yjSortData)[9]["winPrice"]), 1)
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : (_openBlock(), _createBlock(_component_a_empty, {
                key: 1,
                class: "mt-100"
              }))
        ])
      ]),
      _createElementVNode("div", _hoisted_256, [
        _createElementVNode("div", _hoisted_257, [
          _hoisted_258,
          _createElementVNode("div", _hoisted_259, [
            _createElementVNode("div", _hoisted_260, [
              _createElementVNode("div", null, [
                _createVNode(_component_a_tabs, {
                  activeKey: _unref(zhcgKey),
                  "onUpdate:activeKey": _cache[42] || (_cache[42] = ($event: any) => (_isRef(zhcgKey) ? (zhcgKey).value = $event : null)),
                  onChange: selectZhcgKey
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_tab_pane, { key: "2" }, {
                      tab: _withCtx(() => [
                        _hoisted_261
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_tab_pane, {
                      key: "3",
                      "force-render": ""
                    }, {
                      tab: _withCtx(() => [
                        _hoisted_262
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_tab_pane, { key: "5" }, {
                      tab: _withCtx(() => [
                        _hoisted_263
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_tab_pane, { key: "9" }, {
                      tab: _withCtx(() => [
                        _hoisted_264
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["activeKey"])
              ]),
              _createElementVNode("a", {
                onClick: _cache[43] || (_cache[43] = () => toSearch(3))
              }, [
                _createTextVNode(" 查看更多 "),
                _hoisted_265
              ])
            ]),
            _createElementVNode("div", _hoisted_266, [
              (_unref(zhcgData).length)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_unref(zhcgData)[0] || _unref(zhcgData)[1])
                      ? (_openBlock(), _createElementBlock("div", _hoisted_267, [
                          (_unref(zhcgData)[0])
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "table-0",
                                onClick: _cache[44] || (_cache[44] = () => toDetail(_unref(zhcgData)[0].sid))
                              }, [
                                _createElementVNode("div", _hoisted_268, _toDisplayString(_unref(zhcgData)[0]["title"]), 1),
                                _createElementVNode("div", _hoisted_269, [
                                  (
                          _unref(zhcgData)[0]['durations'] &&
                          !['3', '5'].includes(_unref(zhcgKey))
                        )
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (_unref(zhcgData)[0]['durations']['isOvertime'])
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_270, " 公告时间已结束 "))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_271, [
                                              _hoisted_272,
                                              _createElementVNode("span", _hoisted_273, _toDisplayString(_unref(zhcgData)[0]["durations"]["days"]) + " 天 " + _toDisplayString(_unref(zhcgData)[0]["durations"]["hours"]) + " 时 " + _toDisplayString(_unref(zhcgData)[0]["durations"]["minutes"]) + " 分 ", 1)
                                            ]))
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["table-3", 
                          !_unref(zhcgData)[0]['durations'] ||
                          ['3', '5'].includes(_unref(zhcgKey))
                            ? 'right-content'
                            : ''
                        ])
                                  }, _toDisplayString(_unref(zhcgData)[0]["releaseTime"].split(" ")[0]), 3)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_unref(zhcgData)[1])
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: "table-0",
                                onClick: _cache[45] || (_cache[45] = () => toDetail(_unref(zhcgData)[1].sid))
                              }, [
                                _createElementVNode("div", _hoisted_274, _toDisplayString(_unref(zhcgData)[1]["title"]), 1),
                                _createElementVNode("div", _hoisted_275, [
                                  (
                          _unref(zhcgData)[1]['durations'] &&
                          !['3', '5'].includes(_unref(zhcgKey))
                        )
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (_unref(zhcgData)[1]['durations']['isOvertime'])
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_276, " 公告时间已结束 "))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_277, [
                                              _hoisted_278,
                                              _createElementVNode("span", _hoisted_279, _toDisplayString(_unref(zhcgData)[1]["durations"]["days"]) + " 天 " + _toDisplayString(_unref(zhcgData)[1]["durations"]["hours"]) + " 时 " + _toDisplayString(_unref(zhcgData)[1]["durations"]["minutes"]) + " 分 ", 1)
                                            ]))
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["table-3", 
                          !_unref(zhcgData)[1]['durations'] ||
                          ['3', '5'].includes(_unref(zhcgKey))
                            ? 'right-content'
                            : ''
                        ])
                                  }, _toDisplayString(_unref(zhcgData)[1]["releaseTime"].split(" ")[0]), 3)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_unref(zhcgData)[1])
                            ? (_openBlock(), _createElementBlock("div", _hoisted_280))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(zhcgData)[2] || _unref(zhcgData)[3])
                      ? (_openBlock(), _createElementBlock("div", _hoisted_281, [
                          (_unref(zhcgData)[2])
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "table-0",
                                onClick: _cache[46] || (_cache[46] = () => toDetail(_unref(zhcgData)[2].sid))
                              }, [
                                _createElementVNode("div", _hoisted_282, _toDisplayString(_unref(zhcgData)[2]["title"]), 1),
                                _createElementVNode("div", _hoisted_283, [
                                  (
                          _unref(zhcgData)[2]['durations'] &&
                          !['3', '5'].includes(_unref(zhcgKey))
                        )
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (_unref(zhcgData)[2]['durations']['isOvertime'])
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_284, " 公告时间已结束 "))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_285, [
                                              _hoisted_286,
                                              _createElementVNode("span", _hoisted_287, _toDisplayString(_unref(zhcgData)[2]["durations"]["days"]) + " 天 " + _toDisplayString(_unref(zhcgData)[2]["durations"]["hours"]) + " 时 " + _toDisplayString(_unref(zhcgData)[2]["durations"]["minutes"]) + " 分 ", 1)
                                            ]))
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["table-3", 
                          !_unref(zhcgData)[2]['durations'] ||
                          ['3', '5'].includes(_unref(zhcgKey))
                            ? 'right-content'
                            : ''
                        ])
                                  }, _toDisplayString(_unref(zhcgData)[2]["releaseTime"].split(" ")[0]), 3)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_unref(zhcgData)[3])
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: "table-0",
                                onClick: _cache[47] || (_cache[47] = () => toDetail(_unref(zhcgData)[3].sid))
                              }, [
                                _createElementVNode("div", _hoisted_288, _toDisplayString(_unref(zhcgData)[3]["title"]), 1),
                                _createElementVNode("div", _hoisted_289, [
                                  (
                          _unref(zhcgData)[3]['durations'] &&
                          !['3', '5'].includes(_unref(zhcgKey))
                        )
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (_unref(zhcgData)[3]['durations']['isOvertime'])
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_290, " 公告时间已结束 "))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_291, [
                                              _hoisted_292,
                                              _createElementVNode("span", _hoisted_293, _toDisplayString(_unref(zhcgData)[3]["durations"]["days"]) + " 天 " + _toDisplayString(_unref(zhcgData)[3]["durations"]["hours"]) + " 时 " + _toDisplayString(_unref(zhcgData)[3]["durations"]["minutes"]) + " 分 ", 1)
                                            ]))
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["table-3", 
                          !_unref(zhcgData)[3]['durations'] ||
                          ['3', '5'].includes(_unref(zhcgKey))
                            ? 'right-content'
                            : ''
                        ])
                                  }, _toDisplayString(_unref(zhcgData)[3]["releaseTime"].split(" ")[0]), 3)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_unref(zhcgData)[3])
                            ? (_openBlock(), _createElementBlock("div", _hoisted_294))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(zhcgData)[4] || _unref(zhcgData)[5])
                      ? (_openBlock(), _createElementBlock("div", _hoisted_295, [
                          (_unref(zhcgData)[4])
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "table-0",
                                onClick: _cache[48] || (_cache[48] = () => toDetail(_unref(zhcgData)[4].sid))
                              }, [
                                _createElementVNode("div", _hoisted_296, _toDisplayString(_unref(zhcgData)[4]["title"]), 1),
                                _createElementVNode("div", _hoisted_297, [
                                  (
                          _unref(zhcgData)[4]['durations'] &&
                          !['3', '5'].includes(_unref(zhcgKey))
                        )
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (_unref(zhcgData)[4]['durations']['isOvertime'])
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_298, " 公告时间已结束 "))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_299, [
                                              _hoisted_300,
                                              _createElementVNode("span", _hoisted_301, _toDisplayString(_unref(zhcgData)[4]["durations"]["days"]) + " 天 " + _toDisplayString(_unref(zhcgData)[4]["durations"]["hours"]) + " 时 " + _toDisplayString(_unref(zhcgData)[4]["durations"]["minutes"]) + " 分 ", 1)
                                            ]))
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["table-3", 
                          !_unref(zhcgData)[4]['durations'] ||
                          ['3', '5'].includes(_unref(zhcgKey))
                            ? 'right-content'
                            : ''
                        ])
                                  }, _toDisplayString(_unref(zhcgData)[4]["releaseTime"].split(" ")[0]), 3)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_unref(zhcgData)[5])
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: "table-0",
                                onClick: _cache[49] || (_cache[49] = () => toDetail(_unref(zhcgData)[5].sid))
                              }, [
                                _createElementVNode("div", _hoisted_302, _toDisplayString(_unref(zhcgData)[5]["title"]), 1),
                                _createElementVNode("div", _hoisted_303, [
                                  (
                          _unref(zhcgData)[5]['durations'] &&
                          !['3', '5'].includes(_unref(zhcgKey))
                        )
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (_unref(zhcgData)[5]['durations']['isOvertime'])
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_304, " 公告时间已结束 "))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_305, [
                                              _hoisted_306,
                                              _createElementVNode("span", _hoisted_307, _toDisplayString(_unref(zhcgData)[5]["durations"]["days"]) + " 天 " + _toDisplayString(_unref(zhcgData)[5]["durations"]["hours"]) + " 时 " + _toDisplayString(_unref(zhcgData)[5]["durations"]["minutes"]) + " 分 ", 1)
                                            ]))
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["table-3", 
                          !_unref(zhcgData)[5]['durations'] ||
                          ['3', '5'].includes(_unref(zhcgKey))
                            ? 'right-content'
                            : ''
                        ])
                                  }, _toDisplayString(_unref(zhcgData)[5]["releaseTime"].split(" ")[0]), 3)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_unref(zhcgData)[5])
                            ? (_openBlock(), _createElementBlock("div", _hoisted_308))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createElementBlock("div", _hoisted_309, [
                    _createVNode(_component_a_empty)
                  ]))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_310, [
          _hoisted_311,
          (_unref(activeBidData).length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_312, [
                  _hoisted_313,
                  _createElementVNode("span", _hoisted_314, _toDisplayString(_unref(activeBidData)[0]["bidderName"]), 1)
                ]),
                _createElementVNode("div", _hoisted_315, [
                  _hoisted_316,
                  _createElementVNode("span", _hoisted_317, _toDisplayString(_unref(activeBidData)[1]["bidderName"]), 1)
                ]),
                _createElementVNode("div", _hoisted_318, [
                  _hoisted_319,
                  _createElementVNode("span", _hoisted_320, _toDisplayString(_unref(activeBidData)[2]["bidderName"]), 1)
                ]),
                _createElementVNode("div", _hoisted_321, [
                  _hoisted_322,
                  _createElementVNode("span", _hoisted_323, _toDisplayString(_unref(activeBidData)[3]["bidderName"]), 1)
                ]),
                _createElementVNode("div", _hoisted_324, [
                  _hoisted_325,
                  _createElementVNode("span", _hoisted_326, _toDisplayString(_unref(activeBidData)[4]["bidderName"]), 1)
                ]),
                _createElementVNode("div", _hoisted_327, [
                  _hoisted_328,
                  _createElementVNode("span", _hoisted_329, _toDisplayString(_unref(activeBidData)[5]["bidderName"]), 1)
                ]),
                _createElementVNode("div", _hoisted_330, [
                  _hoisted_331,
                  _createElementVNode("span", _hoisted_332, _toDisplayString(_unref(activeBidData)[6]["bidderName"]), 1)
                ]),
                _createElementVNode("div", _hoisted_333, [
                  _hoisted_334,
                  _createElementVNode("span", _hoisted_335, _toDisplayString(_unref(activeBidData)[7]["bidderName"]), 1)
                ]),
                _createElementVNode("div", _hoisted_336, [
                  _hoisted_337,
                  _createElementVNode("span", _hoisted_338, _toDisplayString(_unref(activeBidData)[8]["bidderName"]), 1)
                ]),
                _createElementVNode("div", _hoisted_339, [
                  _hoisted_340,
                  _createElementVNode("span", _hoisted_341, _toDisplayString(_unref(activeBidData)[9]["bidderName"]), 1)
                ])
              ], 64))
            : (_openBlock(), _createBlock(_component_a_empty, {
                key: 1,
                class: "mt-100"
              }))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_342, [
      _createElementVNode("div", _hoisted_343, [
        _createElementVNode("div", _hoisted_344, [
          _createElementVNode("div", _hoisted_345, [
            _hoisted_346,
            _createElementVNode("div", null, [
              _createElementVNode("a", {
                onClick: _cache[50] || (_cache[50] = () => toNewsListPage('/site-statute'))
              }, [
                _createTextVNode(" 查看更多 "),
                _hoisted_347
              ])
            ])
          ]),
          _createElementVNode("ul", _hoisted_348, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(zcfgData), (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.sid,
                onClick: () => toDetailNews(`p_${item.sid}-1`)
              }, _toDisplayString(item.title), 9, _hoisted_349))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_350, [
          _createElementVNode("div", _hoisted_351, [
            _hoisted_352,
            _createElementVNode("div", null, [
              _createElementVNode("a", {
                onClick: _cache[51] || (_cache[51] = () => toNewsListPage('/site-info'))
              }, [
                _createTextVNode(" 查看更多 "),
                _hoisted_353
              ])
            ])
          ]),
          _createElementVNode("ul", _hoisted_354, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(hyzxData), (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.sid,
                onClick: () => toDetailNews(`n_${item.sid}-1`)
              }, _toDisplayString(item.title), 9, _hoisted_355))
            }), 128))
          ])
        ])
      ])
    ]),
    _createVNode(_unref(ContactUs), {
      visible: _unref(contactVisible),
      "onUpdate:visible": _cache[52] || (_cache[52] = ($event: any) => (_isRef(contactVisible) ? (contactVisible).value = $event : null))
    }, null, 8, ["visible"]),
    _createVNode(_unref(NoPermission), {
      visible: _unref(permissionVisible),
      "onUpdate:visible": _cache[53] || (_cache[53] = ($event: any) => (_isRef(permissionVisible) ? (permissionVisible).value = $event : null))
    }, null, 8, ["visible"])
  ]))
}
}

})